const RESTAURANTS = [
  {
    name: 'Wild Thyme Gourmet',
    description:
      'Located in the heart of Highlands, North Carolina, Wild Thyme Gourmet offers a seasonal menu with American cuisine and subtle Asian influences in a relaxed setting.',
  },
  {
    name: 'Highlands Supper Club',
    description:
      'Set in a historic cabin in Highlands, this restaurant offers Southern-inspired dishes, classic comfort food, and a warm, rustic dining atmosphere.',
  },
  {
    name: 'The Vineyard at High Holly',
    description:
      'Located just outside Highlands, this restaurant offers a scenic mountain setting with a relaxed atmosphere and a focus on simple, well-prepared dishes.',
  },
  {
    name: "Madison's Restaurant",
    description:
      "Located at Old Edwards Inn in downtown Highlands, Madison's Restaurant offers a seasonal menu focused on locally sourced ingredients in an elegant setting.",
  },
  {
    name: 'The Blue Bicycle',
    description:
      'A casual café in Highlands known for breakfast and brunch, offering a menu inspired by Southern Appalachian flavors with a light coastal influence.',
  },
];

export default function RestaurantsSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14" id="restaurants">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Where to Eat</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            Restaurants in <em className="italic">Highlands NC</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {RESTAURANTS.map((r) => (
            <div key={r.name} className="bg-white rounded-2xl p-8">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className="ri-restaurant-2-line text-[#2D4A3E] text-base" />
              </div>
              <h3 className="font-cormorant text-xl text-[#1A1A18] font-semibold mb-3">{r.name}</h3>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{r.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 max-w-3xl mx-auto text-center">
          <p className="text-[#5C5850] font-jost text-base leading-relaxed italic">
            Highlands, North Carolina offers a wide range of dining options, from casual cafés to upscale restaurants, many with outdoor seating and a relaxed mountain atmosphere.
          </p>
        </div>
      </div>
    </section>
  );
}
